export default __webpack_public_path__ + "static/media/s2.b759fc59.png";